import React from 'react';

export const ModalBody: React.FC<{ children: React.ReactNode }> = ({
  children
}) => <div className="modal-body">{children}</div>;
